/**
 * Once a full-screen card is answered its action bar sticks to the screen's foot again, where it would cover the
 * card's feedback on a tall card. So the page slides down to its end, where the bar sits under the card: the
 * feedback and Next both show. Nothing moves when the end is already in view.
 */
export function revealBar(host: Element): void {
  if (!host.querySelector('.actionbar:not(.sign-foot)')) return;
  requestAnimationFrame(() => {
    const root = document.scrollingElement;
    if (!root) return;
    const end = root.scrollHeight - window.innerHeight;
    if (window.scrollY >= end - 4) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: end, behavior: reduced ? 'auto' : 'smooth' });
  });
}
